<div class="modal fade" bsModal #modalRef="bs-modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Assign Admin</h4>
      </div>
      <div class="modal-body">
        <form [formGroup]="assignmentForm">
          <div class="form-group">
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px; margin-bottom: 25px">
              <div class="col-lg-2 col-md-3 pl-0 pl-0 titles">Admin</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-12 col-md-12 form-group">
                    <label>Assignee (optional)</label>
                    <ng-select
                      class="assignee-filter"
                      [items]="assignees"
                      formControlName="assignee"
                      bindLabel="name"
                      notFoundText="No assignee found"
                      (change)="onAssigneeSelect($event)"
                      (clear)="clearAssignee()">
                      <ng-template ng-option-tmp let-item="item" let-index="index">
                        <div class="assignee-option">
                          <div class="avatar">{{ getInitials(item.name) }}</div>
                          <div class="details">
                            <span class="name">{{ item.name }}</span>
                            <span *ngIf="item.email" class="email" [title]="item.email">{{ item.email }}</span>
                          </div>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <br />

        <div style="text-align: right">
          <button type="button" class="btn aru btn-secondary" (click)="closeModal()">Close</button>
          <button type="button" class="btn aru btn-primary ml-2" (click)="confirmModal()">Save changes</button>
        </div>
      </div>
    </div>
  </div>
</div>
